import { Slider, type SliderColorVariant } from "../../ui/components/Slider";
import type { EditorSliderProps } from "../types";

interface ExtendedEditorSliderProps extends EditorSliderProps {
  colorVariant?: SliderColorVariant;
}

export function EditorSlider({
  label,
  value,
  min,
  max,
  step,
  onChange,
  onChangeEnd,
  disabled = false,
  colorVariant = "default",
}: ExtendedEditorSliderProps) {
  return (
    <div className="space-y-1">
      <Slider
        label={label}
        value={value}
        minValue={min}
        maxValue={max}
        step={step}
        onChange={onChange}
        onChangeEnd={onChangeEnd}
        isDisabled={disabled}
        colorVariant={colorVariant}
        className="w-full"
      />
    </div>
  );
}
